import indexPtBr from '@locales/pt-BR/index'
import indexEn from '@locales/en/index'

export default {
  'pt-BR': { ...indexPtBr },
  en: { ...indexEn }
}
